import { Navigate } from "react-router-dom";
import finEaseHomeNavigationRoutes from "@/projects/FinEaseHomeAndAdmin/utils/navigationRoutes";

/** Redirect legacy `/admin/role-management` to Users sub-route */
export default function RoleManagementRootRedirect() {
  return (
    <Navigate to={finEaseHomeNavigationRoutes.ROLE_MANAGEMENT_USERS} replace />
  );
}
